<div class="modal-header bg-tertiary">
  <h6 class="modal-title fw-bold">Click</h6>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
  @if (click) {
    <div>
      <div
        class="bg-tertiary p-2 border-start border-warning border-5 mb-3 d-flex align-items-center justify-content-between">
        <h3 class="fw-bold fs-6 mb-0">General</h3>
      </div>
      <table class="table">
        <tbody>
          <tr>
            <th>ID</th>
            <td>{{ click.id }}</td>
          </tr>
          <tr>
            <th> Created at</th>
            <td> {{ click.createdAt | parisDate }}</td>
          </tr>
          <tr>
            <th> Site</th>
            <td> {{ click.site }}</td>
          </tr>
          <tr>
            <th>Brand</th>
            <td>{{ click.product }}</td>
          </tr>
          <tr>
            <th>Offer</th>
            <td>{{ click.offer }}</td>
          </tr>
          <tr>
            <th>Partner</th>
            <td>{{ click.partner }}</td>
          </tr>
          <tr>
            <th>Promotion link</th>
            <td>{{ click.landingPage }}</td>
          </tr>
        </tbody>
      </table>
      <div
        class="bg-tertiary p-2 border-start border-warning border-5 mb-3 d-flex align-items-center justify-content-between mt-5">
        <h3 class="fw-bold fs-6 mb-0">Customer</h3>
      </div>
      <table class="table">
        <tbody>
          <tr>
            <th>Language</th>
            <td>{{ click.language }}</td>
          </tr>
          <tr>
            <th>Country</th>
            <td>
              @if (click.country) {
                <img [ngSrc]="countryService.getFlag(click.country)"
                  [alt]="click.country" width="24" height="24" class="me-1">
              }
            </td>
          </tr>
        </tbody>
      </table>
      <div
        class="bg-tertiary p-2 border-start border-warning border-5 mb-3 d-flex align-items-center justify-content-between mt-5">
        <h3 class="fw-bold fs-6 mb-0">Technical</h3>
      </div>
      <table class="table">
        <tbody>
          <tr>
            <th>IP</th>
            <td>{{ click.ip }}</td>
          </tr>
          <tr>
            <th>User Agent</th>
            <td>{{ click.userAgent }}</td>
          </tr>
          <tr>
            <th>Bot</th>
            <td>
              @if (click.bot) {
                @if (click.botAllowed) {
                  <span>🟢 Allowed</span>
                }
                @if (!click.botAllowed) {
                  <span>⛔ Denied</span>
                }
              }
            </td>
          </tr>
        </tbody>
      </table>
      <div
        class="bg-tertiary p-2 border-start border-warning border-5 mb-3 d-flex align-items-center justify-content-between mt-5">
        <h3 class="fw-bold fs-6 mb-0">Tracking</h3>
      </div>
      <table class="table">
        <tbody>
          <tr>
            <th>Sub ID</th>
            <td>{{ click.subid }}</td>
          </tr>
          <tr>
            <th>TC1</th>
            <td>{{ click.tc1 }}</td>
          </tr>
          <tr>
            <th>TC2</th>
            <td>{{ click.tc2 }}</td>
          </tr>
          <tr>
            <th>TC3</th>
            <td>{{ click.tc3 }}</td>
          </tr>
          <tr>
            <th>TC4</th>
            <td>{{ click.tc4 }}</td>
          </tr>
          <tr>
            <th>Click ID</th>
            <td>{{ click.clickid }}</td>
          </tr>
          <tr>
            <th>Google Ads Click ID</th>
            <td>{{ click.gclid }}</td>
          </tr>
          <tr>
            <th>Google Ads Gbraid</th>
            <td>{{ click.gbraid }}</td>
          </tr>
          <tr>
            <th>Google Ads Wbraid</th>
            <td>{{ click.wbraid }}</td>
          </tr>
          <tr>
            <th>FB Click ID</th>
            <td>{{ click.fbclid }}</td>
          </tr>
          <tr>
            <th>FB Pixel ID</th>
            <td>{{ click.fbpxid }}</td>
          </tr>
          <tr>
            <th>Microsoft Click ID</th>
            <td>{{ click.msclkid }}</td>
          </tr>
          <tr>
            <th>Microsoft Pixel ID</th>
            <td>{{ click.mspxid }}</td>
          </tr>
          <tr>
            <th>X Click ID</th>
            <td>{{ click.twclid }}</td>
          </tr>
          <tr>
            <th>X Pixel ID</th>
            <td>{{ click.twpxid }}</td>
          </tr>
          <tr>
            <th>TikTok Click ID</th>
            <td>{{ click.ttclid }}</td>
          </tr>
          <tr>
            <th>TikTok Pixel ID</th>
            <td>{{ click.ttpxid }}</td>
          </tr>
          <tr>
            <th>Source</th>
            <td>{{ click.source }}</td>
          </tr>
          <tr>
            <th>Referer</th>
            <td>{{ click.referer }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  }
</div>
